import { updateSessionUser } from "../_lib/browserSession";

export function saveData(data) {
  return updateSessionUser(data);
}
